// src/pages/Home.js
import React, { useEffect, useState } from 'react';
import { checkSQLConnection } from '../services/sqlService';
import {
  Chip, Accordion, AccordionSummary, AccordionDetails,
  Button, Typography, Box, Stack, Container, Fab
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import LogoutIcon from '@mui/icons-material/Logout';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const [sqlStatus, setSQLStatus] = useState("Checking...");
  const navigate = useNavigate();
  const [logoutConfirming, setLogoutConfirming] = useState(false);

  useEffect(() => {
    async function testConnections() {
      const sql = await checkSQLConnection();
      setSQLStatus(sql ? "✅ Connected" : "❌ Disconnected");
    }
    testConnections();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4, position: 'relative' }}>
      {/* <Stack direction="row" spacing={2} mb={3}>
        <Chip
          icon={sqlStatus.startsWith("✅") ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
          label={`SQL Server: ${sqlStatus}`}
          color={sqlStatus.startsWith("✅") ? "success" : "error"}
          variant="outlined"
          size="small"
        />
      </Stack> */}

      <Box textAlign="center" mt={8}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Approvals
        </Typography>
        <Stack spacing={2} mt={2}>
          <Button variant="contained" fullWidth size="large" onClick={() => navigate("/po/yarn-fabric")}>
            Yarn / Fabric
          </Button>
          <Button variant="contained" fullWidth size="large" onClick={() => navigate("/po/accessories")}>
            Accessories
          </Button>
        </Stack>
      </Box>


      <ClickAwayListener onClickAway={() => setLogoutConfirming(false)}>
        <Box sx={{ position: 'fixed', bottom: 16, right: 16 }}>
          <Button
            variant="contained"
            color="error"
            onClick={logoutConfirming ? handleLogout : () => setLogoutConfirming(true)}
            startIcon={
              <LogoutIcon
                sx={{
                  transition: 'transform 0.3s ease, margin 0.3s ease',
                  transform: logoutConfirming ? 'translateX(0)' : 'translateX(4px)',
                  ml: logoutConfirming ? 0 : 0.5,
                }}
              />
            }
            sx={{
              borderRadius: '999px',
              minWidth: 0,
              height: 56,
              px: logoutConfirming ? 2 : 1.5,
              width: logoutConfirming ? 'auto' : 56,
              transition: 'all 0.35s ease-in-out',
              display: 'flex',
              alignItems: 'center',
              justifyContent: logoutConfirming ? 'space-between' : 'center',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }}
          >
            <Box
              component="span"
              sx={{
                opacity: logoutConfirming ? 1 : 0,
                width: logoutConfirming ? 'auto' : 0,
                transition: 'opacity 0.2s ease 0.1s, width 0.2s ease',
                ml: 1,
              }}
            >
              SURE?
            </Box>
          </Button>
        </Box>
      </ClickAwayListener>

    </Container>
  );
};

export default Home;